import { gql, useMutation } from "@apollo/client";

const DELETE_DESIGN_BOARD = gql`
  mutation DeleteDesignBoard($designBoardId: ID!) {
    deleteDesignBoard(designBoardId: $designBoardId)
  }
`;

export const useDeleteDesignBoardMutation = () => {
  const [deleteDesignBoardMutation, { loading, error, data }] =
    useMutation(DELETE_DESIGN_BOARD);

  const deleteDesignBoard = async (designBoardId: string) => {
    try {
      const response = await deleteDesignBoardMutation({
        variables: { designBoardId },
      });
      return response.data?.deleteDesignBoard ?? false;
    } catch (deleteError) {
      console.error("Error deleting design board:", deleteError);
      throw deleteError;
    }
  };

  return {
    deleteDesignBoard,
    loading,
    error,
    data,
  };
};
